import { Alert, Divider, H4 } from "@blueprintjs/core";
import { useIsMobile } from "app/jm";

type UnsavedWorkAlertProps = {
  action: "sign out" | "switch users";
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function UnsavedWorkAlert({
  action,
  message,
  onConfirm,
  onCancel,
}: UnsavedWorkAlertProps) {
  const isMobile = useIsMobile();
  const actionLabel = action === "sign out" ? "Sign Out" : "Switch User";
  return (
    <Alert
      isOpen
      cancelButtonText={isMobile ? "Keep Editing" : "No, Keep Editing"}
      confirmButtonText={isMobile ? actionLabel : `Yes, ${actionLabel}`}
      onConfirm={onConfirm}
      onCancel={onCancel}
      intent="warning"
      icon="warning-sign"
    >
      <H4>Unsaved changes</H4>
      <Divider className="m-0" />
      <br />
      <p>Your unsaved changes will be lost. {message}</p>
      <br />
    </Alert>
  );
}
